"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PrescriptionItemInputSchema () {
        return PrescriptionItemInputSchema;
    },
    get PrescriptionItemSchema () {
        return PrescriptionItemSchema;
    },
    get QUANTITY_SUGGESTED_FORMS () {
        return QUANTITY_SUGGESTED_FORMS;
    },
    get suggestQuantity () {
        return suggestQuantity;
    }
});
const _zod = require("zod");
const _medications = require("../medications");
const _prescriptionstatus = require("./prescription-status");
const _prescriptiontext = require("./prescription-text");
const QUANTITY_SUGGESTED_FORMS = [
    'tablet',
    'capsule',
    'sachet'
];
function suggestQuantity(input) {
    if (!QUANTITY_SUGGESTED_FORMS.includes(input.form)) {
        return null;
    }
    if (input.durationDays === null) {
        return null;
    }
    const definition = _medications.PRESCRIPTION_FREQUENCIES.find((entry)=>entry.key === input.frequency);
    if (definition === undefined || definition.perDay === null) {
        return null;
    }
    // Rounded first so 1/7 × 7 lands on 1, not on 1.0000000000000002 → 2.
    const exact = Math.round(definition.perDay * input.durationDays * 1e6) / 1e6;
    return Math.ceil(exact);
}
const itemShape = {
    /** `null` for a free-text line. */ medicationCode: _medications.MedicationCodeSchema.nullable().default(null),
    genericName: (0, _prescriptiontext.requiredLineText)(_prescriptionstatus.PRESCRIPTION_LIMITS.genericName, 'Generic name'),
    strength: (0, _prescriptiontext.requiredLineText)(_prescriptionstatus.PRESCRIPTION_LIMITS.strength, 'Strength'),
    form: _medications.MedicationFormSchema,
    brandName: (0, _prescriptiontext.optionalLineText)(_prescriptionstatus.PRESCRIPTION_LIMITS.brandName, 'Brand name'),
    frequency: _medications.PrescriptionFrequencySchema,
    durationDays: (0, _prescriptiontext.boundedInt)(_prescriptionstatus.PRESCRIPTION_LIMITS.durationDaysMin, _prescriptionstatus.PRESCRIPTION_LIMITS.durationDaysMax, 'Duration (days)').nullable().default(null),
    quantity: (0, _prescriptiontext.boundedInt)(_prescriptionstatus.PRESCRIPTION_LIMITS.quantityMin, _prescriptionstatus.PRESCRIPTION_LIMITS.quantityMax, 'Quantity'),
    refills: (0, _prescriptiontext.boundedInt)(0, _prescriptionstatus.PRESCRIPTION_LIMITS.refillsMax, 'Refills').default(0),
    sig: (0, _prescriptiontext.optionalLineText)(_prescriptionstatus.PRESCRIPTION_LIMITS.sig, 'Instructions')
};
const PrescriptionItemInputSchema = _zod.z.object(itemShape).strict();
const PrescriptionItemSchema = _zod.z.object({
    position: (0, _prescriptiontext.boundedInt)(1, _prescriptionstatus.PRESCRIPTION_LIMITS.itemsMax, 'position'),
    ...itemShape
}).strict();
